import React, { useState, useEffect, useRef } from "react";
import Message from "../../../../utils/modals/Message";
import Cards from "../../../../dynamic-components/Cards";
import PopupCards from "../../../../dynamic-components/PopupCards";
import CreateShipmentModal from "../../../../utils/modals/shipment-tab/CreateShipmentModal";
import EditShipmentModal from "../../../../utils/modals/shipment-tab/edit-shipment/EditShipmentModal";
import ShipmentTable from "./ShipmentTable";
import TabNavCards from "../../../../dynamic-components/TabNavCards";
import {
    shipmentSwitcher_1,
    shipmentSwitcher_2,
} from "../../../../utils/extra/cards/swichers";
import { getShipmentCardsSetData } from "../../../../../context/api/cards/shipment-tab/getShipmentCardsSetData";
import { getShipmentTableSetData } from "../../../../../context/api/tables/home/shipment-tab/getShipmentTableSetData";
import Spinner from "react-bootstrap/Spinner";
import { useCookies } from "react-cookie";
import { shippingPdfApi } from "../../../../../context/api/reports/shipping-reports/shippingPdfApi";

const ShipmentTab = ({ lang, data }) => {
    // cookies 
    const [cookies] = useCookies();
    // init variables 
    const initialMessageRes = {
        success: Boolean,
        Message: String,
        isShow: false
    }
    const initialAddModal = {
        isShow: false,
        action: "",
        rowData: {},
    };
    // states 
    const fetched = useRef(false);
    const cardAction = useRef();
    const [activeCard, setActiveCard] = useState("totalShipments");
    const [messageResponse, setMessageResponse] = useState(initialMessageRes);
    const [cardsData, setCardsData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [tableLoader, setTableLoader] = useState(true);
    const [btnLoader, setBtnLoader] = useState(false);
    // states modals 
    const [showAddModal, setShowAddModal] = useState(initialAddModal);
    const [showEditModal, setShowEditModal] = useState(initialAddModal);
    const [refreshData, setRefreshData] = useState(0);
    const [menuLoading, setMenuLoading] = useState(false);
    const [menuData, setMenuData] = useState([]);
    // hooks 
    // events handlers 

    // logics
    const fetchOnStart = async () => {
        fetched.current = false;
        const userId = data.id;

        await getShipmentCardsSetData(
            lang,
            setMessageResponse,
            cookies,
            setCardsData,
            userId
        );
        await getShipmentTableSetData(
            lang,
            setMessageResponse,
            cookies,
            activeCard,
            setTableData,
            setTableLoader,
            userId
        );
        fetched.current = true;
    };

    useEffect(() => {
        fetchOnStart();
    }, [refreshData]);

    if (!fetched.current) {
        return (
            <div className="page_loader">
                <Spinner animation="border" variant="warning" />
            </div>
        );
    }

    const fetchTableData = async (key) => {
        setTableLoader(() => true);
        if (key) {
            cardAction.current = key;
        }
        const customer_id = data.id;
        await getShipmentTableSetData(
            lang,
            setMessageResponse,
            cookies,
            cardAction.current,
            setTableData,
            setTableLoader,
            customer_id
        );
    };

    const dataCard1 = cardsData.rightArray;
    const dataCard2 = cardsData.leftArray[activeCard];

    const navCards = {
        fullName: data.fullName,
        code: data.customer_code,
        phoneNumber: data.phoneNumber,
    };

    const getPdf = async () => {
        const userId = data.id;
        setBtnLoader(() => true);
        await shippingPdfApi(cookies, setMessageResponse, setBtnLoader, userId);
    };

    return (
        <>
            <Message
                messageResponse={messageResponse}
                close={() => setMessageResponse(initialMessageRes)}
                lang={lang}
            />

            <CreateShipmentModal
                show={showAddModal.isShow}
                onHide={() => {
                    setShowAddModal(initialAddModal)
                    setMenuLoading(false);
                }}
                lang={lang}
                action={showAddModal.action}
                userId={data.id}
                data={showAddModal.rowData}
                setRefreshData={setRefreshData}
                menuLoading={menuLoading}
                menuData={menuData}
            />
            <EditShipmentModal
                show={showEditModal.isShow}
                onHide={() => {
                    setShowEditModal(initialAddModal)
                    setMenuLoading(false);
                }}
                lang={lang}
                action={showEditModal.action}
                userId={data.id}
                data={showEditModal.rowData}
                setRefreshData={setRefreshData}
                menuLoading={menuLoading}
                menuData={menuData}
            />

            <div className="customerShipments_tab">
                <TabNavCards data={navCards} />
                <PopupCards
                    pageClass="customerShipments_tab"
                    lang={lang}
                    dataCard1={dataCard1}
                    dataCard2={dataCard2}
                    switcher_1={shipmentSwitcher_1}
                    switcher_2={shipmentSwitcher_2}
                    activeCard={activeCard}
                    setActiveCard={setActiveCard}
                    fetchTableData={fetchTableData}
                />
                <ShipmentTable
                    lang={lang}
                    loader={tableLoader}
                    tableData={tableData.length > 0 ? tableData : ""}
                    setShowAddModal={setShowAddModal}
                    setShowEditModal={setShowEditModal}
                    setRefreshData={setRefreshData}
                    btnLoader={btnLoader}
                    getPdf={getPdf}
                    setMenuLoading={setMenuLoading}
                    setMenuData={setMenuData}
                />
            </div>
        </>
    );
}

export default ShipmentTab;

